import { useContext } from "react";
import { ProjectContext } from "context/ProjectProvider";
import DistributionGroup from "pages/distribution-group";

function DistribuionGroupsSettings() {
  const { gqlClientForProject, tokenContents } = useContext(ProjectContext);

  return (
    <DistributionGroup
      gqlClientForProject={gqlClientForProject}
      tokenContents={tokenContents}
    />
  );
}

export default DistribuionGroupsSettings;
